import { render, staticRenderFns } from "./DetailClassAcceleration.vue?vue&type=template&id=e783162e&scoped=true"
import script from "./DetailClassAcceleration.vue?vue&type=script&lang=js"
export * from "./DetailClassAcceleration.vue?vue&type=script&lang=js"
import style0 from "./detailClassAcceleration.css?vue&type=style&index=0&id=e783162e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e783162e",
  null
  
)

export default component.exports